const projects = [
  {
    number: "01",
    title: "Scalable Chat Backend",
    description:
      "A real-time chat architecture designed around Node.js, Socket.IO, Redis and Kafka with support for one-to-one and group messaging.",
    tags: [
      "Node.js",
      "Socket.IO",
      "Redis",
      "Kafka"
    ],
    github: "https://github.com/akshayecs"
  },
  {
    number: "02",
    title: "Smart ATS",
    description:
      "An AI-powered candidate tracking platform concept covering resume processing, candidate workflows and asynchronous backend jobs.",
    tags: [
      "Node.js",
      "RabbitMQ",
      "AI",
      "PostgreSQL"
    ],
    github: "https://github.com/akshayecs"
  },
  {
    number: "03",
    title: "Dynamic Report Builder",
    description:
      "Backend architecture for configurable, tenant-aware reports with reusable filters, data processing and optimized API responses.",
    tags: [
      "Node.js",
      "SQL",
      "REST API",
      "Performance"
    ],
    github: "https://github.com/akshayecs"
  },
  {
    number: "04",
    title: "API & Authentication Systems",
    description:
      "Reusable backend patterns for secure authentication, authorization, validation, database access and production-ready REST APIs.",
    tags: [
      "Express.js",
      "JWT",
      "MySQL",
      "Docker"
    ],
    github: "https://github.com/akshayecs"
  }
];

export default function Projects() {
  return (
    <section
      id="projects"
      className="section"
    >
      <div className="container">

        <div className="section-heading section-heading-row">

          <div>

            <p className="section-kicker">
              Selected work
            </p>

            <h2>
              Projects built around real
              engineering problems.
            </h2>

          </div>

          <a
            className="button button-secondary small-button"
            href="https://github.com/akshayecs"
            target="_blank"
            rel="noreferrer"
          >
            All GitHub Projects ↗
          </a>

        </div>

        <div className="projects-grid">

          {projects.map((project) => (
            <article
              className="project-card"
              key={project.title}
            >

              <div className="project-topline">

                <span>
                  {project.number}
                </span>

                <a
                  href={project.github}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={`Open ${project.title} on GitHub`}
                >
                  ↗
                </a>

              </div>

              <div
                className="project-icon"
                aria-hidden="true"
              >
                &lt;/&gt;
              </div>

              <h3>
                {project.title}
              </h3>

              <p>
                {project.description}
              </p>

              <div className="tag-list">

                {project.tags.map((tag) => (
                  <span key={tag}>
                    {tag}
                  </span>
                ))}

              </div>

              <a
                className="text-link"
                href={project.github}
                target="_blank"
                rel="noreferrer"
              >
                View project
                <span aria-hidden="true">
                  →
                </span>
              </a>

            </article>
          ))}

        </div>

      </div>
    </section>
  );
}